import React from "react";
import PropTypes from "prop-types";

// @material-ui/icons
import Add from "@material-ui/icons/Add";
import Apps from "@material-ui/icons/Apps";
import ImportExport from "@material-ui/icons/ImportExport";
import DateRange from "@material-ui/icons/DateRange";
import Update from "@material-ui/icons/Update";
import People from "@material-ui/icons/People";

import EthAlt from 'react-cryptocoins/dist/icons/ETH-alt';

import { withStyles, Grid } from "material-ui";

import { StatsCard, ChartCard, ActionCard, ItemGrid, DappIcon, Button } from "components";

import dashboardStyle from "assets/jss/material-dashboard-react/dashboardStyle";

import DocumentMeta from 'react-document-meta';
import InfiniteScroll from 'react-infinite-scroll-component';
import Reflux from 'reflux';
import createReactClass from 'create-react-class';
import DappsStore from '../../stores/DappsStore';


const DappsList = createReactClass({
    mixins: [
        Reflux.connect(DappsStore, "data")
    ],
    getInitialState: function() {
        return {
            dapps: [],
            currentCount: 6,
        };
    },
    componentWillReceiveProps(nextProps) {
        // console.info(nextProps);
        let dapps = [];
        if (typeof nextProps.dapps !== 'undefined') {
            dapps = nextProps.dapps;
        }
        this.setState({
            dapps: dapps,
        // currentCount: 6,
        });
    },
    getItems: function() {
        let dapps = this.state.dapps.filter(this.searchFilter);
        dapps = dapps.slice(0, this.state.currentCount);
        return dapps.map((value, index) => (
            <ItemGrid key={ index } xs={12} sm={6} md={4}>
                <ChartCard
            chart={ <DappIcon size={150} dapp={ value } style={ {
                marginTop: '4px',
                marginLeft: '4px',
                background: 'white',
                borderRadius: '50%'
            }} /> }
            data={ value }
            text={ value.description }
            statText={ value.category }
            statLink={{
                text: value.category,
                href: '/' + value.category + 's'
            }}
            />
          </ItemGrid>
        ));
    },
    hasMore: function(itemsCount) {
        if (itemsCount === 12) return false;
        return this.state.dapps.length > this.state.currentCount && itemsCount === this.state.currentCount;
    },
    fetchMoreData: function() {
        //setTimeout(() => {
        let newCount;
        if (this.state.currentCount > 12) {
            newCount = this.state.currentCount + parseInt(this.state.currentCount / 2, 10);
        } else {
            newCount = this.state.currentCount + 6;
        }
        this.setState({
            currentCount: newCount
        });
    //}, 50)
    },
    onClickLoadMore: function() {
        this.props.preloadDapps();
        this.setState({
            currentCount: this.state.currentCount + 6
        });
    },
    loadMoreButton: function(itemsCount) {
        if (itemsCount !== 12) return false;
        return <Button color="success" style={{
                margin: "0 auto",
                width: "200px"
            }} onClick={this.onClickLoadMore}>
                Show More
            </Button>
    },
    render() {
        let items = this.getItems();
        return <InfiniteScroll
            dataLength={this.state.currentCount} //This is important field to render the next data
            next={this.fetchMoreData}
            hasMore={this.hasMore(items.length)}
            loader={
            <p style={{
                textAlign: 'center'
            }}>
              <b>Loading...</b>
            </p>
            }
            refreshFunction={this.fetchMoreData}
            scrollableTarget="mainPanel"
            ><Grid container>
          { items }
          { this.loadMoreButton(items.length)}
        </Grid>
        </InfiniteScroll>
    },
    searchFilter(value) {
        return value.title.toLowerCase().indexOf(DappsStore.data.searchQuery.toLowerCase()) !== -1 ||
            value.description.toLowerCase().indexOf(DappsStore.data.searchQuery.toLowerCase()) !== -1;
    },
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
});

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.preloadAllDapps = this.preloadAllDapps.bind(this);
        this.updateDappsData = this.updateDappsData.bind(this);
    }

    state = {
        value: 0,
        sort: 'hot',
        appsIndexes: [],
        totalDAU: 0,
        totalBalance: 0,
        limit: 5,
    };

    handleChange = (event, value) => {
        this.setState({
            value
        });
    };

    handleChangeIndex = index => {
        this.setState({
            value: index
        });
    };

    componentWillMount() {
        let self = this;
        DappsStore.getHeadDataPromise.then(function() {
            self.updateDappsData();
            self.preloadAllDapps();
        });
    }

    preloadAllDapps() {
        let self = this;
        DappsStore.getAllDapps().then(function(e) {
            self.updateDappsData();
        });
    }

    updateDappsData() {
        let filter = this.getFilterByPath();
        let dapps = DappsStore.data.dapps;

        if (filter) {
            dapps = dapps.filter((element) => element.category === filter);
        }

        //dapps.sort(DappsStore.sortDau);
        dapps = this.sortDapps(dapps, this.state.sort);

        let categoryCounters = DappsStore.getCountersCategory(filter);

        let totalDApps = categoryCounters.dapps;
        let totalDAU = categoryCounters.dau;
        let totalBalance = categoryCounters.balance;
        let totalTx = categoryCounters.tx;

        this.setState({
            appsIndexes: dapps,
            totalDAU: totalDAU,
            totalBalance: totalBalance,
            totalTx: totalTx,
            totalDApps: totalDApps,
        })
    }

    sortDapps(dapps, sort) {
        switch (sort) {
        case 'hot':
            dapps.sort(DappsStore.sortPreviousDau);
            break;
        case 'popular':
            dapps.sort(DappsStore.sortBalance);
            break;
        case 'all':
        default:
            dapps.sort((a, b) => (b.id - a.id));
            break;
        }
        return dapps;
    }

    sortAllDapps(sort) {
        let self = this;
        let filter = this.getFilterByPath();
        DappsStore.getAllDapps().then(function(e) {
            let dapps = DappsStore.data.dapps;
            if (filter) {
                dapps = dapps.filter((element) => element.category === filter);
            }
            dapps = self.sortDapps(dapps, sort);

            self.setState({
                sort: sort,
                appsIndexes: dapps.slice(0, 2000),
            });
        });
    }


    numberFormat(number, rounding) {
        rounding = typeof rounding === 'undefined' ? 0 : rounding;
        if (typeof number === 'undefined') {
            return 0;
        }
        if (number >= 100000 && number > rounding) {
            return (number / 1000).toFixed(0) + 'K';
        } else if (number > 1000 && number > rounding) {
            return (number / 1000).toFixed(1) + 'K';
        } else {
            return Math.round(number);
        }
    }

    getFilterByPath() {
        switch (this.props.location.pathname) {
        case '/games':
            return 'game';
        case '/marketplaces':
            return 'marketplace';
        case '/casinos':
            return 'casino';
        case '/pyramids':
            return 'pyramid';
        case '/tools':
            return 'tool';
        case '/collectibles':
            return 'collectible';
        case '/others':
            return 'other';
        default:
            return '';
        }
    }

    getTitleByPath() {
        switch (this.props.location.pathname) {
        case '/games':
            return 'Games on Blockcain';
        case '/marketplaces':
            return 'Marketplaces on Blockcain';
        case '/casinos':
            return 'Casinos on Blockcain';
        case '/pyramids':
            return 'Pyramids on Blockcain';
        case '/tools':
            return 'Tools on Blockcain';
        case '/collectibles':
            return 'Crypto Collectibles';
        case '/others':
            return 'DApps';
        default:
            return 'DApp Store';
        }
    }

    getDescriptionByPath() {
        switch (this.props.location.pathname) {
        case '/games':
            return 'Games on Blockcain';
        case '/marketplaces':
            return 'Marketplaces on Blockcain';
        case '/casinos':
            return 'Casinos on Blockcain';
        case '/pyramids':
            return 'Pyramids on Blockcain';
        case '/tools':
            return 'Tools on Blockcain';
        case '/collectibles':
            return 'A crypto-collectible game on the Ethereum blockchain.';
        case '/others':
            return 'Apps on Blockcain';
        default:
            return 'DApp Store - Projects Built on Blockchain';
        }
    }

    getUrlByPath() {
        return 'https://dappstore.link' + this.props.location.pathname;
    }

    render() {

        const meta = {
            title: this.getTitleByPath(),
            description: this.getDescriptionByPath(),
            canonical: this.getUrlByPath(),
            meta: {
                property: {
                    'og:title': this.getTitleByPath(),
                    'og:description': this.getDescriptionByPath(),
                    'og:url': this.getUrlByPath()
                }
            }
        };

        return (
            <DocumentMeta {...meta}>


        <Grid container>

          <ItemGrid xs={12} sm={6} md={6} lg={3}>
            <StatsCard
            icon={Apps}
            iconColor="orange"
            title="Total DApps"
            description={ this.numberFormat(this.state.totalDApps, 10000)}
            statIcon={Add}
            statIconColor="success"
            statLink={{
                text: "Submit ÐApp",
                href: "https://t.me/RomanGladun"
            }}
            />
          </ItemGrid>
          <ItemGrid xs={12} sm={6} md={6} lg={3}>
            <StatsCard
            icon={People}
            iconColor="green"
            title="Total DAU"
            description={ this.numberFormat(this.state.totalDAU)}
            statIcon={DateRange}
            statText="Daily active users today"
            />
          </ItemGrid>
          <ItemGrid xs={12} sm={6} md={6} lg={3}>
            <StatsCard
            icon={EthAlt}
            iconColor="red"
            title="Balance"
            description={ this.numberFormat(this.state.totalBalance)}
            statIcon={EthAlt}
            statText="Total balance on contracts"
            />
          </ItemGrid>
          <ItemGrid xs={12} sm={6} md={6} lg={3}>
            <StatsCard
            icon={ImportExport}
            iconColor="blue"
            title="Transactions"
            description={ this.numberFormat(this.state.totalTx)}
            statIcon={Update}
            statText="Daily transactions"
            />
          </ItemGrid>
          <ItemGrid xs={12} sm={12} md={12} lg={12}>
            <ActionCard sort = { (e) => this.sortAllDapps(e)} />
          </ItemGrid>
        </Grid>

        

        <DappsList dapps={ this.state.appsIndexes } preloadDapps={ this.preloadAllDapps } />
    
      </DocumentMeta>
        );
    }
}

Dashboard.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx